import { Avatar, Box, ButtonBase } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { IconMenu2 } from '@tabler/icons'
import PropTypes from 'prop-types'
import React from 'react'
import { Logo } from './../Main'
import ChatSection from './chat'
import NotificationSection from './notification/NotificationSection'
import ProfileSection from './profile'
import LanguageSection from './language'

const Header = ({
  handleLeftDrawerToggle,
  sidebar = false,
  language = false,
  chat = false,
  notification = false,
  profile = false,
}) => {
  const theme = useTheme()

  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          width: 228,
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto',
          },
        }}
      >
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
          <Logo />
        </Box>
        <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
          {sidebar && (
            <Avatar
              variant="rounded"
              sx={{
                ...theme.typography.commonAvatar,
                ...theme.typography.mediumAvatar,
                transition: 'all .2s ease-in-out',
                background: 'transparent',
                color: theme.palette.secondary.dark,
                '&:hover': {
                  background: theme.palette.secondary.light,
                  color: theme.palette.grey[50],
                },
              }}
              onClick={handleLeftDrawerToggle}
              color="inherit"
            >
              <IconMenu2
                stroke={1.5}
                size="1.3rem"
                sx={{
                  background: 'transparent',
                  color: theme.palette.grey[700],
                  '&:hover': {
                    background: 'transparent',
                    color: theme.palette.primary.main,
                  },
                }}
              />
            </Avatar>
          )}
        </ButtonBase>
      </Box>

      <Box sx={{ flexGrow: 1 }} />
      {language && <LanguageSection />}
      {chat && <ChatSection />}
      {notification && <NotificationSection />}
      {profile && <ProfileSection />}
    </>
  )
}

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func,
  sidebar: PropTypes.bool,
  language: PropTypes.bool,
  chat: PropTypes.bool,
  notification: PropTypes.bool,
  profile: PropTypes.bool,
}

export default Header
